var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['py-2', 'px-4', 'base-text', 'elevation-1', {'base-color': _vm.isOwner, 'owner-color': !_vm.isOwner}],attrs:{"elevation":"1"}},[_vm._v(" "+_vm._s(_vm.$attrs.value)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }